import { aboutData } from "../../data/aboutData";

function About() {
  return (
    <section
      id="about"
      className="py-20 px-6 md:px-12 lg:px-20 bg-hero-background border-l-4 border-purple-600"
    >
      <div className="max-w-4xl mx-auto">
        <h1 className="font-display text-4xl md:text-5xl font-bold text-purple-600 mb-4">
          About Me
        </h1>
        <h2 className="font-body text-xl font-semibold text-muted-foreground mb-8">
          {aboutData.current_title}
        </h2>
        <p
          id="about-description"
          className="font-body text-lg text-hero-foreground/80 leading-relaxed mb-12 scroll-mt-20"
        >
          {aboutData.description}
        </p>

        {aboutData.skills && aboutData.skills.length > 0 && (
          <div id="skills" className="mb-12 scroll-mt-20">
            <h2 className="font-display text-2xl font-bold text-hero-foreground mb-6">
              Skills
            </h2>
            <ul className="flex flex-wrap gap-2">
              {aboutData.skills.map((skill, index) => (
                <li
                  key={index}
                  className="inline-block px-3 py-1 bg-purple-600/10 border border-purple-600/20 rounded-full text-sm font-body text-purple-600"
                >
                  {skill}
                </li>
              ))}
            </ul>
          </div>
        )}

        {aboutData.education && (
          <div id="education" className="mb-12 scroll-mt-20">
            <h2 className="font-display text-2xl font-bold text-hero-foreground mb-6">
              Education
            </h2>
            <div className="p-6 bg-white/50 rounded-lg border border-black/5 hover:border-black/10 transition-colors">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-xl font-bold text-hero-foreground mb-2">
                    {aboutData.education.institution}
                  </h3>
                  <p className="font-body text-lg text-purple-600 mb-1">
                    {aboutData.education.degree}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span>{aboutData.education.duration}</span>
                    <span>•</span>
                    <span>{aboutData.education.location}</span>
                  </div>
                </div>
                {aboutData.education.link && (
                  <a
                    href={aboutData.education.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-shrink-0 text-green-600 hover:text-green-700 transition-colors"
                    aria-label={`Verify ${aboutData.education.institution}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {aboutData.certifications && aboutData.certifications.length > 0 && (
          <div id="certifications" className="mb-12 scroll-mt-20">
            <h2 className="font-display text-2xl font-bold text-hero-foreground mb-6">
              Certifications
            </h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {aboutData.certifications.map((cert, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between gap-3 p-4 bg-white/50 rounded-lg border border-black/5 hover:border-black/10 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <span className="inline-block w-2 h-2 bg-purple-600 rounded-full flex-shrink-0"></span>
                    <span className="font-body text-hero-foreground">
                      {cert.name}
                    </span>
                  </div>
                  {cert.link && (
                    <a
                      href={cert.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-shrink-0 text-green-600 hover:text-green-700 transition-colors"
                      aria-label={`Verify ${cert.name}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}

export default About;
